
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sales/make-offer/[property-id]",
      function () {
        return require("private-next-pages/sales/make-offer/[property-id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sales/make-offer/[property-id]"])
      });
    }
  